var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.73c39224fcf5708ad58bec4cde6c34ad.svg#s';
                    var viewUrl = 'sprites.73c39224fcf5708ad58bec4cde6c34ad.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };